import { styled, Box } from '@mui/material';

export const StyledContentWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: '0px',
  marginTop: '1rem'
});
